"use strict";

var _templateObject, _templateObject2, _templateObject3;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _ = require("esm-env");

require("./plugins.js");

var u = function u(n, t, e) {
  var i = document.createElement(n),
      _ref = Array.isArray(t) ? [void 0, t] : [t, e],
      _ref2 = _slicedToArray(_ref, 2),
      s = _ref2[0],
      a = _ref2[1];

  return s && Object.assign(i, s), a == null || a.forEach(function (r) {
    return i.appendChild(r);
  }), i;
},
    I = function I(n, t) {
  var _ref3;

  var e;
  return t === "left" ? n.offsetLeft : ((_ref3 = (e = n.offsetParent instanceof HTMLElement ? n.offsetParent : null) == null ? void 0 : e.offsetWidth) !== null && _ref3 !== void 0 ? _ref3 : 0) - n.offsetWidth - n.offsetLeft;
},
    X = function X(n) {
  return n.offsetWidth > 0 && n.offsetHeight > 0;
},
    z = function z(n, t) {
  _.BROWSER && !customElements.get(n) && customElements.define(n, t);
};

function q(n, t) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$reverse = _ref4.reverse,
      e = _ref4$reverse === void 0 ? !1 : _ref4$reverse;

  var i = n.length;

  for (var s = e ? i - 1 : 0; e ? s >= 0 : s < i; e ? s-- : s++) {
    t(n[s], s);
  }
}

function Y(n, t, e, i) {
  var s = t.formatToParts(n);
  e && s.unshift({
    type: "prefix",
    value: e
  }), i && s.push({
    type: "suffix",
    value: i
  });

  var a = [],
      r = [],
      o = [],
      c = [],
      d = {},
      p = function p(h) {
    var _d$h;

    return "".concat(h, ":").concat(d[h] = ((_d$h = d[h]) !== null && _d$h !== void 0 ? _d$h : -1) + 1);
  };

  var x = "",
      g = !1,
      y = !1;

  var _iterator = _createForOfIteratorHelper(s),
      _step;

  try {
    var _loop = function _loop() {
      var h = _step.value;
      x += h.value;
      var l = h.type === "minusSign" || h.type === "plusSign" ? "sign" : h.type;
      l === "integer" ? (g = !0, r.push.apply(r, _toConsumableArray(h.value.split("").map(function (R) {
        return {
          type: l,
          value: parseInt(R)
        };
      })))) : l === "group" ? r.push({
        type: l,
        value: h.value
      }) : l === "decimal" ? (y = !0, o.push({
        type: l,
        value: h.value,
        key: p(l)
      })) : l === "fraction" ? o.push.apply(o, _toConsumableArray(h.value.split("").map(function (R) {
        return {
          type: l,
          value: parseInt(R),
          key: p(l),
          pos: -1 - d[l]
        };
      }))) : (g || y ? c : a).push({
        type: l,
        value: h.value,
        key: p(l)
      });
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var P = [];

  for (var h = r.length - 1; h >= 0; h--) {
    var l = r[h];
    P.unshift(l.type === "integer" ? _objectSpread(_objectSpread({}, l), {}, {
      key: p(l.type),
      pos: d[l.type]
    }) : _objectSpread(_objectSpread({}, l), {}, {
      key: p(l.type)
    }));
  }

  return {
    pre: a,
    integer: P,
    fraction: o,
    post: c,
    valueAsString: x,
    value: typeof n == "string" ? parseFloat(n) : n
  };
}

var G = String.raw,
    V = String.raw,
    K = _.BROWSER && function () {
  try {
    document.createElement("div").animate({
      opacity: 0
    }, {
      easing: "linear(0, 1)"
    });
  } catch (_unused) {
    return !1;
  }

  return !0;
}(),
    Z = _.BROWSER && (typeof CSS === "undefined" ? "undefined" : _typeof(CSS)) < "u" && CSS.supports && CSS.supports("line-height", "mod(1,1)"),
    $ = _.BROWSER && (typeof matchMedia === "undefined" ? "undefined" : _typeof(matchMedia)) < "u" ? matchMedia("(prefers-reduced-motion: reduce)") : null,
    S = "--_number-flow-d-opacity",
    U = "--_number-flow-d-width",
    E = "--_number-flow-dx",
    j = "--_number-flow-d",
    J = function () {
  try {
    return CSS.registerProperty({
      name: S,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: E,
      syntax: "<length>",
      inherits: !0,
      initialValue: "0px"
    }), CSS.registerProperty({
      name: U,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: j,
      syntax: "<number>",
      inherits: !0,
      initialValue: "0"
    }), !0;
  } catch (_unused2) {
    return !1;
  }
}(),
    T = "var(--number-flow-char-height, 1em)",
    f = "var(--number-flow-mask-height, 0.25em)",
    C = "calc(".concat(f, " / 2)"),
    A = "var(--number-flow-mask-width, 0.5em)",
    m = "calc(".concat(A, " / var(--scale-x))"),
    v = "#000 0, transparent 71%",
    L = V(_templateObject || (_templateObject = _taggedTemplateLiteral([":host{display:inline-block;direction:ltr;white-space:nowrap;isolation:isolate;line-height:", " !important}.number,.number__inner{display:inline-block;transform-origin:left top}:host([data-will-change]) :is(.number,.number__inner,.section,.digit,.digit__num,.symbol){will-change:transform}.number{--scale-x:calc(1 + var(", ") / var(--width));transform:translateX(var(", ")) scaleX(var(--scale-x));margin:0 calc(-1 * ", ");position:relative;-webkit-mask-image:linear-gradient(to right,transparent 0,#000 ", ",#000 calc(100% - ", "),transparent ),linear-gradient(to bottom,transparent 0,#000 ", ",#000 calc(100% - ", "),transparent 100% ),radial-gradient(at bottom right,", "),radial-gradient(at bottom left,", "),radial-gradient(at top left,", "),radial-gradient(at top right,", ");-webkit-mask-size:100% calc(100% - ", " * 2),calc(100% - ", " * 2) 100%,", " ", ",", " ", ",", " ", ",", " ", ";-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat}.number__inner{padding:", " ", ";transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(", void 0, ")}.digit__num,.number .section::after{padding:", " 0}.digit__num{display:inline-block;--offset-raw:mod(var(--length) + var(--n) - mod(var(--c),var(--length)),var(--length));--offset:calc( var(--offset-raw) - var(--length) * round(down,var(--offset-raw) / (var(--length) / 2),1) );--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y))}.digit__num[inert]{position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y))}.digit:not(.is-spinning) .digit__num[inert]{display:none}.symbol__value{display:inline-block;mix-blend-mode:plus-lighter;white-space:pre}.section--justify-left .symbol > [inert]{left:0}.section--justify-right .symbol > [inert]{right:0}.animate-presence{opacity:calc(1 + var(", "))}"], [":host{display:inline-block;direction:ltr;white-space:nowrap;isolation:isolate;line-height:", " !important}.number,.number__inner{display:inline-block;transform-origin:left top}:host([data-will-change]) :is(.number,.number__inner,.section,.digit,.digit__num,.symbol){will-change:transform}.number{--scale-x:calc(1 + var(", ") / var(--width));transform:translateX(var(", ")) scaleX(var(--scale-x));margin:0 calc(-1 * ", ");position:relative;-webkit-mask-image:linear-gradient(to right,transparent 0,#000 ", ",#000 calc(100% - ", "),transparent ),linear-gradient(to bottom,transparent 0,#000 ", ",#000 calc(100% - ", "),transparent 100% ),radial-gradient(at bottom right,", "),radial-gradient(at bottom left,", "),radial-gradient(at top left,", "),radial-gradient(at top right,", ");-webkit-mask-size:100% calc(100% - ", " * 2),calc(100% - ", " * 2) 100%,", " ", ",", " ", ",", " ", ",", " ", ";-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat}.number__inner{padding:", " ", ";transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(", ")))}:host > :not(.number){z-index:5}.section,.symbol{display:inline-block;position:relative;isolation:isolate}.section::after{content:'\\200b';display:inline-block}.section--justify-left{transform-origin:center left}.section--justify-right{transform-origin:center right}.section > [inert],.symbol > [inert]{margin:0 !important;position:absolute !important;z-index:-1}.digit{display:inline-block;position:relative;--c:var(--current) + var(", ")}.digit__num,.number .section::after{padding:", " 0}.digit__num{display:inline-block;--offset-raw:mod(var(--length) + var(--n) - mod(var(--c),var(--length)),var(--length));--offset:calc( var(--offset-raw) - var(--length) * round(down,var(--offset-raw) / (var(--length) / 2),1) );--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y))}.digit__num[inert]{position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y))}.digit:not(.is-spinning) .digit__num[inert]{display:none}.symbol__value{display:inline-block;mix-blend-mode:plus-lighter;white-space:pre}.section--justify-left .symbol > [inert]{left:0}.section--justify-right .symbol > [inert]{right:0}.animate-presence{opacity:calc(1 + var(", "))}"])), T, U, E, A, m, m, f, f, v, v, v, v, f, m, m, f, m, f, m, f, m, f, C, A, E, j, C, S),
    B = _.BROWSER ? HTMLElement : /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  return _class;
}(),
    Q = V(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{display:inline-block;direction:ltr;white-space:nowrap;line-height:", " !important}span{display:inline-block}:host([data-will-change]) span{will-change:transform}.number,.digit{padding:", " 0}.symbol{white-space:pre}"])), T, C),
    tt = function tt(n) {
  return "<span class=\"".concat(n.type === "integer" || n.type === "fraction" ? "digit" : "symbol", "\" part=\"").concat(n.type === "integer" || n.type === "fraction" ? "digit ".concat(n.type, "-digit") : "symbol ".concat(n.type), "\">").concat(n.value, "</span>");
},
    w = function w(n, t) {
  return "<span part=\"".concat(t, "\">").concat(n.reduce(function (e, i) {
    return e + tt(i);
  }, ""), "</span>");
},
    et = function et(n) {
  return G(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<template shadowroot=\"open\" shadowrootmode=\"open\"\n\t\t\t><style>\n\t\t\t\t", "</style\n\t\t\t><span role=\"img\" aria-label=\"", "\"\n\t\t\t\t>", "<span part=\"number\" class=\"number\"\n\t\t\t\t\t>", "", "</span\n\t\t\t\t>", "</span\n\t\t\t></template\n\t\t><span\n\t\t\tstyle=\"font-kerning: none; display: inline-block; line-height: ", " !important; padding: ", " 0;\"\n\t\t\t>", "</span\n\t\t>"])), Q, n.valueAsString, w(n.pre, "left"), w(n.integer, "integer"), w(n.fraction, "fraction"), w(n.post, "right"), T, f, n.valueAsString);
},
    D = Z && K && J;

var b;

var H = /*#__PURE__*/function (_B) {
  _inherits(H, _B);

  var _super = _createSuper(H);

  function H() {
    var _this;

    _classCallCheck(this, H);

    _this = _super.call(this), _this.created = !1, _this.batched = !1;

    var _this$constructor$def = _this.constructor.defaultProps,
        t = _this$constructor$def.animated,
        e = _objectWithoutProperties(_this$constructor$def, ["animated"]);

    _this._animated = _this.computedAnimated = t, Object.assign(_assertThisInitialized(_this), e);
    return _this;
  }

  _createClass(H, [{
    key: "animated",
    get: function get() {
      return this._animated;
    },
    set: function set(t) {
      var e;
      this.animated !== t && (this._animated = t, (e = this.shadowRoot) == null || e.getAnimations().forEach(function (i) {
        return i.finish();
      }));
    }
  }, {
    key: "data",
    set: function set(t) {
      var _this2 = this;

      var o;
      if (t == null) return;
      var e = t.pre,
          i = t.integer,
          s = t.fraction,
          a = t.post,
          r = t.value;

      if (this.created) {
        var c = this._data;
        this._data = t, this.computedTrend = typeof this.trend == "function" ? this.trend(c.value, r) : this.trend, this.computedAnimated = D && this._animated && (!this.respectMotionPreference || !($ != null && $.matches)) && X(this), (o = this.plugins) == null || o.forEach(function (d) {
          var p;
          return (p = d.onUpdate) == null ? void 0 : p.call(d, t, c, _this2);
        }), this.batched || this.willUpdate(), this._pre.update(e), this._num.update({
          integer: i,
          fraction: s
        }), this._post.update(a), this.batched || this.didUpdate();
      } else {
        this._data = t, this.attachShadow({
          mode: "open"
        });

        try {
          var _this$_internals;

          (_this$_internals = this._internals) !== null && _this$_internals !== void 0 ? _this$_internals : this._internals = this.attachInternals(), this._internals.role = "img";
        } catch (_unused3) {}

        if ((typeof CSSStyleSheet === "undefined" ? "undefined" : _typeof(CSSStyleSheet)) < "u" && this.shadowRoot.adoptedStyleSheets) b || (b = new CSSStyleSheet(), b.replaceSync(L)), this.shadowRoot.adoptedStyleSheets = [b];else {
          var _c = document.createElement("style");

          _c.textContent = L, this.shadowRoot.appendChild(_c);
        }
        this._pre = new N(this, e, {
          justify: "right",
          part: "left"
        }), this.shadowRoot.appendChild(this._pre.el), this._num = new it(this, i, s), this.shadowRoot.appendChild(this._num.el), this._post = new N(this, a, {
          justify: "left",
          part: "right"
        }), this.shadowRoot.appendChild(this._post.el), this.created = !0;
      }

      try {
        this._internals.ariaLabel = t.valueAsString;
      } catch (_unused4) {}
    }
  }, {
    key: "willUpdate",
    value: function willUpdate() {
      this._pre.willUpdate(), this._num.willUpdate(), this._post.willUpdate();
    }
  }, {
    key: "didUpdate",
    value: function didUpdate() {
      var _this3 = this;

      if (!this.computedAnimated) return;
      this._abortAnimationsFinish ? this._abortAnimationsFinish.abort() : this.dispatchEvent(new Event("animationsstart")), this._pre.didUpdate(), this._num.didUpdate(), this._post.didUpdate();
      var t = new AbortController();
      Promise.all(this.shadowRoot.getAnimations().map(function (e) {
        return e.finished;
      })).then(function () {
        t.signal.aborted || (_this3.dispatchEvent(new Event("animationsfinish")), _this3._abortAnimationsFinish = void 0);
      }), this._abortAnimationsFinish = t;
    }
  }]);

  return H;
}(B);

H.defaultProps = {
  transformTiming: {
    duration: 900,
    easing: "linear(0,.005,.019,.039,.066,.096,.129,.165,.202,.24,.278,.316,.354,.39,.426,.461,.494,.526,.557,.586,.614,.64,.665,.689,.711,.731,.751,.769,.786,.802,.817,.831,.844,.856,.867,.877,.887,.896,.904,.912,.919,.925,.931,.937,.942,.947,.951,.955,.959,.962,.965,.968,.971,.973,.976,.978,.98,.981,.983,.984,.986,.987,.988,.989,.99,.991,.992,.992,.993,.994,.994,.995,.995,.996,.996,.9963,.9967,.9969,.9972,.9975,.9977,.9979,.9981,.9982,.9984,.9985,.9987,.9988,.9989,1)"
  },
  spinTiming: void 0,
  opacityTiming: {
    duration: 450,
    easing: "ease-out"
  },
  animated: !0,
  trend: function trend(n, t) {
    return Math.sign(t - n);
  },
  respectMotionPreference: !0,
  plugins: void 0,
  digits: void 0
};

var it = /*#__PURE__*/function () {
  function it(t, e, i) {
    var _ref5 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        s = _ref5.className,
        a = _objectWithoutProperties(_ref5, ["className"]);

    _classCallCheck(this, it);

    this.flow = t, this._integer = new W(t, e, {
      justify: "right",
      part: "integer"
    }), this._fraction = new W(t, i, {
      justify: "left",
      part: "fraction"
    }), this._inner = u("span", {
      className: "number__inner"
    }, [this._integer.el, this._fraction.el]), this.el = u("span", _objectSpread(_objectSpread({}, a), {}, {
      part: "number",
      className: "number ".concat(s !== null && s !== void 0 ? s : "")
    }), [this._inner]);
  }

  _createClass(it, [{
    key: "willUpdate",
    value: function willUpdate() {
      this._prevWidth = this.el.offsetWidth, this._prevLeft = this.el.getBoundingClientRect().left, this._integer.willUpdate(), this._fraction.willUpdate();
    }
  }, {
    key: "update",
    value: function update(_ref6) {
      var t = _ref6.integer,
          e = _ref6.fraction;
      this._integer.update(t), this._fraction.update(e);
    }
  }, {
    key: "didUpdate",
    value: function didUpdate() {
      var _this$el$animate;

      var t = this.el.getBoundingClientRect();
      this._integer.didUpdate(), this._fraction.didUpdate();
      var e = this._prevLeft - t.left,
          i = this.el.offsetWidth,
          s = this._prevWidth - i;
      this.el.style.setProperty("--width", String(i)), this.el.animate((_this$el$animate = {}, _defineProperty(_this$el$animate, E, ["".concat(e, "px"), "0px"]), _defineProperty(_this$el$animate, U, [s, 0]), _this$el$animate), _objectSpread(_objectSpread({}, this.flow.transformTiming), {}, {
        composite: "accumulate"
      }));
    }
  }]);

  return it;
}();

var O = /*#__PURE__*/function () {
  function O(t, e, _ref7, r) {
    var _this4 = this;

    var i = _ref7.justify,
        s = _ref7.className,
        a = _objectWithoutProperties(_ref7, ["justify", "className"]);

    _classCallCheck(this, O);

    this.flow = t, this.children = new Map(), this.onCharRemove = function (c) {
      return function () {
        _this4.children.delete(c);
      };
    }, this.justify = i;
    var o = e.map(function (c) {
      return _this4.addChar(c).el;
    });
    this.el = u("span", _objectSpread(_objectSpread({}, a), {}, {
      className: "section section--justify-".concat(i, " ").concat(s !== null && s !== void 0 ? s : "")
    }), r ? r(o) : o);
  }

  _createClass(O, [{
    key: "addChar",
    value: function addChar(t) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref8$startDigitsAtZe = _ref8.startDigitsAtZero,
          e = _ref8$startDigitsAtZe === void 0 ? !1 : _ref8$startDigitsAtZe,
          i = _objectWithoutProperties(_ref8, ["startDigitsAtZero"]);

      var s = t.type === "integer" || t.type === "fraction" ? new M(this, t.type, e ? 0 : t.value, t.pos, _objectSpread(_objectSpread({}, i), {}, {
        onRemove: this.onCharRemove(t.key)
      })) : new st(this, t.type, t.value, _objectSpread(_objectSpread({}, i), {}, {
        onRemove: this.onCharRemove(t.key)
      }));
      return this.children.set(t.key, s), s;
    }
  }, {
    key: "unpop",
    value: function unpop(t) {
      t.el.removeAttribute("inert"), t.el.style.top = "", t.el.style[this.justify] = "";
    }
  }, {
    key: "pop",
    value: function pop(t) {
      var _this5 = this;

      t.forEach(function (e) {
        e.el.style.top = "".concat(e.el.offsetTop, "px"), e.el.style[_this5.justify] = "".concat(I(e.el, _this5.justify), "px");
      }), t.forEach(function (e) {
        e.el.setAttribute("inert", ""), e.present = !1;
      });
    }
  }, {
    key: "addNewAndUpdateExisting",
    value: function addNewAndUpdateExisting(t) {
      var _this6 = this;

      var e = new Map(),
          i = new Map(),
          s = this.justify === "left",
          a = s ? "prepend" : "append";

      if (q(t, function (r) {
        var o;
        _this6.children.has(r.key) ? (o = _this6.children.get(r.key), i.set(r, o), _this6.unpop(o), o.present = !0) : (o = _this6.addChar(r, {
          startDigitsAtZero: !0,
          animateIn: !0
        }), e.set(r, o)), _this6.el[a](o.el);
      }, {
        reverse: s
      }), this.flow.computedAnimated) {
        var r = this.el.getBoundingClientRect();
        e.forEach(function (o) {
          o.willUpdate(r);
        });
      }

      e.forEach(function (r, o) {
        r.update(o.value);
      }), i.forEach(function (r, o) {
        r.update(o.value);
      });
    }
  }, {
    key: "willUpdate",
    value: function willUpdate() {
      var t = this.el.getBoundingClientRect();
      this._prevOffset = t[this.justify], this.children.forEach(function (e) {
        return e.willUpdate(t);
      });
    }
  }, {
    key: "didUpdate",
    value: function didUpdate() {
      var t = this.el.getBoundingClientRect();
      this.children.forEach(function (s) {
        return s.didUpdate(t);
      });
      var e = t[this.justify],
          i = this._prevOffset - e;
      i && this.children.size && this.el.animate({
        transform: ["translateX(".concat(i, "px)"), "none"]
      }, _objectSpread(_objectSpread({}, this.flow.transformTiming), {}, {
        composite: "accumulate"
      }));
    }
  }]);

  return O;
}();

var W = /*#__PURE__*/function (_O) {
  _inherits(W, _O);

  var _super2 = _createSuper(W);

  function W() {
    _classCallCheck(this, W);

    return _super2.apply(this, arguments);
  }

  _createClass(W, [{
    key: "update",
    value: function update(t) {
      var _this7 = this;

      var e = new Map();
      this.children.forEach(function (i, s) {
        t.find(function (a) {
          return a.key === s;
        }) || e.set(s, i), _this7.unpop(i);
      }), this.addNewAndUpdateExisting(t), e.forEach(function (i) {
        i instanceof M && i.update(0);
      }), this.pop(e);
    }
  }]);

  return W;
}(O);

var N = /*#__PURE__*/function (_O2) {
  _inherits(N, _O2);

  var _super3 = _createSuper(N);

  function N() {
    _classCallCheck(this, N);

    return _super3.apply(this, arguments);
  }

  _createClass(N, [{
    key: "update",
    value: function update(t) {
      var e = new Map();
      this.children.forEach(function (i, s) {
        t.find(function (a) {
          return a.key === s;
        }) || e.set(s, i);
      }), this.pop(e), this.addNewAndUpdateExisting(t);
    }
  }]);

  return N;
}(O);

var k = /*#__PURE__*/function () {
  function k(t, e) {
    var _this8 = this;

    var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        i = _ref9.onRemove,
        _ref9$animateIn = _ref9.animateIn,
        s = _ref9$animateIn === void 0 ? !1 : _ref9$animateIn;

    _classCallCheck(this, k);

    this.flow = t, this.el = e, this._present = !0, this._remove = function () {
      var a;
      _this8.el.remove(), (a = _this8._onRemove) == null || a.call(_this8);
    }, this.el.classList.add("animate-presence"), this.flow.computedAnimated && s && this.el.animate(_defineProperty({}, S, [-.9999, 0]), _objectSpread(_objectSpread({}, this.flow.opacityTiming), {}, {
      composite: "accumulate"
    })), this._onRemove = i;
  }

  _createClass(k, [{
    key: "present",
    get: function get() {
      return this._present;
    },
    set: function set(t) {
      if (this._present !== t) {
        if (this._present = t, t ? this.el.removeAttribute("inert") : this.el.setAttribute("inert", ""), !this.flow.computedAnimated) {
          t || this._remove();
          return;
        }

        this.el.style.setProperty("--_number-flow-d-opacity", t ? "0" : "-.999"), this.el.animate(_defineProperty({}, S, t ? [-.9999, 0] : [.999, 0]), _objectSpread(_objectSpread({}, this.flow.opacityTiming), {}, {
          composite: "accumulate"
        })), t ? this.flow.removeEventListener("animationsfinish", this._remove) : this.flow.addEventListener("animationsfinish", this._remove, {
          once: !0
        });
      }
    }
  }]);

  return k;
}();

var F = /*#__PURE__*/function (_k) {
  _inherits(F, _k);

  var _super4 = _createSuper(F);

  function F(t, e, i, s) {
    var _this9;

    _classCallCheck(this, F);

    _this9 = _super4.call(this, t.flow, i, s), _this9.section = t, _this9.value = e, _this9.el = i;
    return _this9;
  }

  return F;
}(k);

var M = /*#__PURE__*/function (_F) {
  _inherits(M, _F);

  var _super5 = _createSuper(M);

  function M(t, e, i, s, a) {
    var _ref10;

    var _this10;

    _classCallCheck(this, M);

    var d, p;
    var r = ((_ref10 = (p = (d = t.flow.digits) == null ? void 0 : d[s]) == null ? void 0 : p.max) !== null && _ref10 !== void 0 ? _ref10 : 9) + 1,
        o = Array.from({
      length: r
    }).map(function (x, g) {
      var y = u("span", {
        className: "digit__num"
      }, [document.createTextNode(String(g))]);
      return g !== i && y.setAttribute("inert", ""), y.style.setProperty("--n", String(g)), y;
    }),
        c = u("span", {
      part: "digit ".concat(e, "-digit"),
      className: "digit"
    }, o);
    c.style.setProperty("--current", String(i)), c.style.setProperty("--length", String(r)), _this10 = _super5.call(this, t, i, c, a), _this10.pos = s, _this10._onAnimationsFinish = function () {
      _this10.el.classList.remove("is-spinning");
    }, _this10._numbers = o, _this10.length = r;
    return _this10;
  }

  _createClass(M, [{
    key: "willUpdate",
    value: function willUpdate(t) {
      var e = this.el.getBoundingClientRect();
      this._prevValue = this.value;
      var i = e[this.section.justify] - t[this.section.justify],
          s = e.width / 2;
      this._prevCenter = this.section.justify === "left" ? i + s : i - s;
    }
  }, {
    key: "update",
    value: function update(t) {
      this.el.style.setProperty("--current", String(t)), this._numbers.forEach(function (e, i) {
        return i === t ? e.removeAttribute("inert") : e.setAttribute("inert", "");
      }), this.value = t;
    }
  }, {
    key: "didUpdate",
    value: function didUpdate(t) {
      var _this$flow$spinTiming;

      var e = this.el.getBoundingClientRect(),
          i = e[this.section.justify] - t[this.section.justify],
          s = e.width / 2,
          a = this.section.justify === "left" ? i + s : i - s,
          r = this._prevCenter - a;
      r && this.el.animate({
        transform: ["translateX(".concat(r, "px)"), "none"]
      }, _objectSpread(_objectSpread({}, this.flow.transformTiming), {}, {
        composite: "accumulate"
      }));
      var o = this.getDelta();
      o && (this.el.classList.add("is-spinning"), this.el.animate(_defineProperty({}, j, [-o, 0]), _objectSpread(_objectSpread({}, (_this$flow$spinTiming = this.flow.spinTiming) !== null && _this$flow$spinTiming !== void 0 ? _this$flow$spinTiming : this.flow.transformTiming), {}, {
        composite: "accumulate"
      })), this.flow.addEventListener("animationsfinish", this._onAnimationsFinish, {
        once: !0
      }));
    }
  }, {
    key: "getDelta",
    value: function getDelta() {
      var i;

      if (this.flow.plugins) {
        var _iterator2 = _createForOfIteratorHelper(this.flow.plugins),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var s = _step2.value;
            var a = (i = s.getDelta) == null ? void 0 : i.call(s, this.value, this._prevValue, this);
            if (a != null) return a;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      var t = this.value - this._prevValue,
          e = this.flow.computedTrend || Math.sign(t);
      return e < 0 && this.value > this._prevValue ? this.value - this.length - this._prevValue : e > 0 && this.value < this._prevValue ? this.length - this._prevValue + this.value : t;
    }
  }]);

  return M;
}(F);

var st = /*#__PURE__*/function (_F2) {
  _inherits(st, _F2);

  var _super6 = _createSuper(st);

  function st(t, e, i, s) {
    var _this11;

    _classCallCheck(this, st);

    var a = u("span", {
      className: "symbol__value",
      textContent: i
    });
    _this11 = _super6.call(this, t, i, u("span", {
      part: "symbol ".concat(e),
      className: "symbol"
    }, [a]), s), _this11.type = e, _this11._children = new Map(), _this11._onChildRemove = function (r) {
      return function () {
        _this11._children.delete(r);
      };
    }, _this11._children.set(i, new k(_this11.flow, a, {
      onRemove: _this11._onChildRemove(i)
    }));
    return _this11;
  }

  _createClass(st, [{
    key: "willUpdate",
    value: function willUpdate(t) {
      if (this.type === "decimal") return;
      var e = this.el.getBoundingClientRect();
      this._prevOffset = e[this.section.justify] - t[this.section.justify];
    }
  }, {
    key: "update",
    value: function update(t) {
      if (this.value !== t) {
        var e = this._children.get(this.value);

        e && (e.present = !1);

        var i = this._children.get(t);

        if (i) i.present = !0;else {
          var s = u("span", {
            className: "symbol__value",
            textContent: t
          });
          this.el.appendChild(s), this._children.set(t, new k(this.flow, s, {
            animateIn: !0,
            onRemove: this._onChildRemove(t)
          }));
        }
      }

      this.value = t;
    }
  }, {
    key: "didUpdate",
    value: function didUpdate(t) {
      if (this.type === "decimal") return;
      var i = this.el.getBoundingClientRect()[this.section.justify] - t[this.section.justify],
          s = this._prevOffset - i;
      s && this.el.animate({
        transform: ["translateX(".concat(s, "px)"), "none"]
      }, _objectSpread(_objectSpread({}, this.flow.transformTiming), {}, {
        composite: "accumulate"
      }));
    }
  }]);

  return st;
}(F);

exports.Digit = M;
exports.NumberFlowLite = H;
exports.ServerSafeHTMLElement = B;
exports.canAnimate = D;
exports.define = z;
exports.formatToData = Y;
exports.prefersReducedMotion = $;
exports.renderInnerHTML = et;